// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Banner headerbar that provides all buttons on present */
#headerbar-banner {
	background: linear-gradient(to bottom, 
		var(--scouting-america-blue) 0%, 
		var(--scouting-america-dark-blue) 100%);

	width: 100%;
	height: 110px;

	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 1000;

	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

#headerbar-info-ctr {
	width: 100%;
	height: 70px;

	padding-top: 0px;
	padding-bottom: 0px;
	
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	border-bottom: 1px solid var(--scouting-america-pale-blue);
}

#headerbar-logo-ctr {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;

	text-decoration: none;
	
	transition: transform 0.2s ease;
}
#headerbar-bsat312-name {
	color: var(--scouting-america-white);
	
	font-size: var(--body-big-size);
	font-weight: var(--font-bolder);
	letter-spacing: 0.5px;
}

#headerbar-extnav-ctr {
	height: 55px;
	
	padding: 4px;
	
	display: flex;
	align-items: center;
	gap: 10px;
}

#headerbar-nav-ctr {
	background-color: var(--scouting-america-dark-blue);

	width: 100%;
	height: 50px;

	display: flex;
	justify-content: space-around;
	align-items: center;

	gap: 2px;
}




/* Expandable headerbar that can expand to display buttons */
#headerbar-expandable {
	background: linear-gradient(
		to bottom,
		var(--scouting-america-blue) 0%,
		var(--scouting-america-dark-blue) 100%
	);

	width: 100%;
	height: 50px;

	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 1000;

	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

#headerbar-collapse-btn {
	background-color: transparent;
	fill: var(--scouting-america-pale-blue);

	width: 40px;
	height: 40px;

	margin-left: auto;

	border-radius: 6px;

	cursor: pointer;

	transition: all 0.25s ease;
}
	#headerbar-collapse-btn:hover {
		background-color:	var(--scouting-america-red);
		fill: var(--scouting-america-white);
	}

#headerbar-return-btn {
	background-color: transparent;
	fill: var(--scouting-america-pale-blue);

	width: 40px;
	height: 40px;

	margin-left: auto;
	margin-right: 10px;
	margin-top: 5px;
	margin-bottom: 5px;

	border-radius: 6px;

	cursor: pointer;

	transition: all 0.25s ease;
}
	#headerbar-return-btn:hover {
		background-color: var(--scouting-america-red);
		fill: var(--scouting-america-white);
	}

#headerbar-collapse-navctr {
	background: linear-gradient(
		to bottom,
		var(--scouting-america-blue) 0px,
		var(--scouting-america-dark-blue) 50px
	);

	width: 0vw;
	height: 100vh;
	z-index: 2000;

	position: fixed;
	right: 0;
	top: 0;

	display: flex;
	flex-direction: column;
	align-items: center;

	overflow: hidden;

	transition: all 0.25s ease;
}



@media (min-width: 551px) {
	#headerbar-info-ctr {
		padding-left: 20px;
		padding-right: 20px;
	}

	.headerbar-bsa-logo {
		width: 45px;
		height: 45px;
	}

	#headerbar-expandable {
		display: none;
	}
}

@media (max-width: 550px) and (min-width: 451px) {
	#headerbar-info-ctr {
		padding-left: 10px;
		padding-right: 10px;
	}

	.headerbar-bsa-logo {
		width: 45px;
		height: 45px;
	}

	#headerbar-bsat312-name {
		display: none;
	}

	#headerbar-expandable {
		display: none;
	}
}

@media (max-width: 450px) {
	#headerbar-banner {
		display: none;
	}

	#headerbar-expandable {
		display: flex;
		flex-direction: row;
		align-items: center;

		padding-left: 10px;
		padding-right: 10px;
	}

	.headerbar-bsa-logo {
		width: 40px;
		height: 40px;

		margin-right: auto;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/HeaderBar/HeaderBar.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;CACC;;yCAEwC;;CAExC,WAAW;CACX,aAAa;;CAEb,eAAe;CACf,QAAQ;CACR,SAAS;CACT,aAAa;;CAEb,yCAAyC;AAC1C;;AAEA;CACC,WAAW;CACX,YAAY;;CAEZ,gBAAgB;CAChB,mBAAmB;;CAEnB,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,mBAAmB;;CAEnB,0DAA0D;AAC3D;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,SAAS;;CAET,qBAAqB;;CAErB,+BAA+B;AAChC;AACA;CACC,oCAAoC;;CAEpC,+BAA+B;CAC/B,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,YAAY;;CAEZ,YAAY;;CAEZ,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,mDAAmD;;CAEnD,WAAW;CACX,YAAY;;CAEZ,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;;CAEnB,QAAQ;AACT;;;;;AAKA,4DAA4D;AAC5D;CACC;;;;EAIC;;CAED,WAAW;CACX,YAAY;;CAEZ,eAAe;CACf,QAAQ;CACR,SAAS;CACT,aAAa;;CAEb,yCAAyC;AAC1C;;AAEA;CACC,6BAA6B;CAC7B,uCAAuC;;CAEvC,WAAW;CACX,YAAY;;CAEZ,iBAAiB;;CAEjB,kBAAkB;;CAElB,eAAe;;CAEf,0BAA0B;AAC3B;CACC;EACC,6CAA6C;EAC7C,mCAAmC;CACpC;;AAED;CACC,6BAA6B;CAC7B,uCAAuC;;CAEvC,WAAW;CACX,YAAY;;CAEZ,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;;CAElB,kBAAkB;;CAElB,eAAe;;CAEf,0BAA0B;AAC3B;CACC;EACC,6CAA6C;EAC7C,mCAAmC;CACpC;;AAED;CACC;;;;EAIC;;CAED,UAAU;CACV,aAAa;CACb,aAAa;;CAEb,eAAe;CACf,QAAQ;CACR,MAAM;;CAEN,aAAa;CACb,sBAAsB;CACtB,mBAAmB;;CAEnB,gBAAgB;;CAEhB,0BAA0B;AAC3B;;;;AAIA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;;EAEnB,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,YAAY;;EAEZ,kBAAkB;CACnB;AACD","sourcesContent":["/* Banner headerbar that provides all buttons on present */\n#headerbar-banner {\n\tbackground: linear-gradient(to bottom, \n\t\tvar(--scouting-america-blue) 0%, \n\t\tvar(--scouting-america-dark-blue) 100%);\n\n\twidth: 100%;\n\theight: 110px;\n\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0px;\n\tz-index: 1000;\n\n\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n#headerbar-info-ctr {\n\twidth: 100%;\n\theight: 70px;\n\n\tpadding-top: 0px;\n\tpadding-bottom: 0px;\n\t\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\tborder-bottom: 1px solid var(--scouting-america-pale-blue);\n}\n\n#headerbar-logo-ctr {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tgap: 12px;\n\n\ttext-decoration: none;\n\t\n\ttransition: transform 0.2s ease;\n}\n#headerbar-bsat312-name {\n\tcolor: var(--scouting-america-white);\n\t\n\tfont-size: var(--body-big-size);\n\tfont-weight: var(--font-bolder);\n\tletter-spacing: 0.5px;\n}\n\n#headerbar-extnav-ctr {\n\theight: 55px;\n\t\n\tpadding: 4px;\n\t\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 10px;\n}\n\n#headerbar-nav-ctr {\n\tbackground-color: var(--scouting-america-dark-blue);\n\n\twidth: 100%;\n\theight: 50px;\n\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\n\tgap: 2px;\n}\n\n\n\n\n/* Expandable headerbar that can expand to display buttons */\n#headerbar-expandable {\n\tbackground: linear-gradient(\n\t\tto bottom,\n\t\tvar(--scouting-america-blue) 0%,\n\t\tvar(--scouting-america-dark-blue) 100%\n\t);\n\n\twidth: 100%;\n\theight: 50px;\n\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0px;\n\tz-index: 1000;\n\n\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n#headerbar-collapse-btn {\n\tbackground-color: transparent;\n\tfill: var(--scouting-america-pale-blue);\n\n\twidth: 40px;\n\theight: 40px;\n\n\tmargin-left: auto;\n\n\tborder-radius: 6px;\n\n\tcursor: pointer;\n\n\ttransition: all 0.25s ease;\n}\n\t#headerbar-collapse-btn:hover {\n\t\tbackground-color:\tvar(--scouting-america-red);\n\t\tfill: var(--scouting-america-white);\n\t}\n\n#headerbar-return-btn {\n\tbackground-color: transparent;\n\tfill: var(--scouting-america-pale-blue);\n\n\twidth: 40px;\n\theight: 40px;\n\n\tmargin-left: auto;\n\tmargin-right: 10px;\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n\n\tborder-radius: 6px;\n\n\tcursor: pointer;\n\n\ttransition: all 0.25s ease;\n}\n\t#headerbar-return-btn:hover {\n\t\tbackground-color: var(--scouting-america-red);\n\t\tfill: var(--scouting-america-white);\n\t}\n\n#headerbar-collapse-navctr {\n\tbackground: linear-gradient(\n\t\tto bottom,\n\t\tvar(--scouting-america-blue) 0px,\n\t\tvar(--scouting-america-dark-blue) 50px\n\t);\n\n\twidth: 0vw;\n\theight: 100vh;\n\tz-index: 2000;\n\n\tposition: fixed;\n\tright: 0;\n\ttop: 0;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\n\toverflow: hidden;\n\n\ttransition: all 0.25s ease;\n}\n\n\n\n@media (min-width: 551px) {\n\t#headerbar-info-ctr {\n\t\tpadding-left: 20px;\n\t\tpadding-right: 20px;\n\t}\n\n\t.headerbar-bsa-logo {\n\t\twidth: 45px;\n\t\theight: 45px;\n\t}\n\n\t#headerbar-expandable {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 550px) and (min-width: 451px) {\n\t#headerbar-info-ctr {\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t}\n\n\t.headerbar-bsa-logo {\n\t\twidth: 45px;\n\t\theight: 45px;\n\t}\n\n\t#headerbar-bsat312-name {\n\t\tdisplay: none;\n\t}\n\n\t#headerbar-expandable {\n\t\tdisplay: none;\n\t}\n}\n\n@media (max-width: 450px) {\n\t#headerbar-banner {\n\t\tdisplay: none;\n\t}\n\n\t#headerbar-expandable {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t}\n\n\t.headerbar-bsa-logo {\n\t\twidth: 40px;\n\t\theight: 40px;\n\n\t\tmargin-right: auto;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
